import React from 'react';
import { FiEdit3, FiVideo } from 'react-icons/fi';

const ShareTypeModal = ({ 
  showShareTypeModal, 
  setShowShareTypeModal, 
  proceedWithScreenShare 
}) => {
  // Agar state false hai, toh kuch render mat karo
  if (!showShareTypeModal) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-gray-800 p-6 rounded-2xl border border-gray-600 max-w-md w-full shadow-2xl mx-4">
        <h2 className="text-xl font-bold mb-2 text-white">What are you sharing?</h2>
        <p className="text-gray-400 text-sm mb-6">This helps us optimize the stream quality for your viewers.</p>
        
        <div className="space-y-4">
          {/* Text/Code Option */}
          <button 
            onClick={() => proceedWithScreenShare('text')}
            className="w-full flex items-start p-4 bg-gray-700/50 hover:bg-gray-700 rounded-xl border border-transparent hover:border-blue-500 transition-all"
          >
            <div className="bg-blue-500/20 p-3 rounded-lg mr-4">
              <FiEdit3 className="h-6 w-6 text-blue-400" />
            </div>
            <div className="text-left">
              <div className="text-white font-semibold">Text, Code, or Documents</div>
              <div className="text-gray-400 text-xs mt-1">High sharpness, low framerate (Best for readability)</div>
            </div>
          </button>

          {/* Video/Motion Option */}
          <button 
            onClick={() => proceedWithScreenShare('video')}
            className="w-full flex items-start p-4 bg-gray-700/50 hover:bg-gray-700 rounded-xl border border-transparent hover:border-green-500 transition-all"
          >
            <div className="bg-green-500/20 p-3 rounded-lg mr-4">
              <FiVideo className="h-6 w-6 text-green-400" />
            </div>
            <div className="text-left">
              <div className="text-white font-semibold">Video, Animation, or YouTube</div>
              <div className="text-gray-400 text-xs mt-1">Smooth motion, standard sharpness (Best for videos)</div>
            </div>
          </button>
        </div>

        <button 
          onClick={() => setShowShareTypeModal(false)}
          className="w-full mt-6 py-3 bg-transparent hover:bg-gray-700 text-gray-300 rounded-xl font-medium transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ShareTypeModal;